import React from "react";
import { motion } from "framer-motion";
import LandingLayout from "../LandingLayout";
import "../caseFunnel/caseFunnel.css";
import { PLATFORM_BRAND, PARENT_COMPANY } from "../config";
import { CheckBadge, ConfettiBurst } from "../caseFunnel/Celebration";
import { BuyerMessage, ContactButtons, FirmBlock, NextSteps } from "./ThankYouParts";

const Banner = ({ testId, className, children }) => (
  <div className={`mx-auto max-w-md rounded px-4 py-2 text-[11px] font-bold uppercase tracking-[0.12em] ${className}`} data-testid={testId}>{children}</div>
);

export const CaseThankYou = ({
  ty, firm, buyerCode, logoUrl, phone, showCall, buyerMessage, customHeadline, accent, reference, isTest, isDemo, tracking,
}) => {
  const headline = customHeadline || (firm ? `You're matched with ${firm}` : "Your case request is in");
  const sub = firm
    ? `${firm}'s intake team will reach out shortly at the number you gave us. Keep your phone nearby so you don't miss them.`
    : `${PLATFORM_BRAND} — a ${PARENT_COMPANY} company — is connecting your case with an injury attorney in your state. Keep your phone nearby.`;
  return (
    <LandingLayout brand={firm} hidePhone={!showCall} brandPhone={phone} buyerCode={buyerCode}>
      {tracking}
      <div className="cf-root relative min-h-[75vh] overflow-hidden bg-[#0a1929] text-slate-200" style={{ "--cf-accent": accent }} data-testid="thank-you-container">
        <div className="cf-glow" aria-hidden="true" />
        <div className="cf-grain" aria-hidden="true" />
        <ConfettiBurst />
        <div className="relative mx-auto max-w-3xl px-5 py-14 text-center sm:py-20" data-testid="lp-thankyou-case">
          {isDemo && (
            <Banner testId="lp-thankyou-demo-banner" className="mb-6 bg-slate-800 text-slate-100">
              Private preview — this is what a real lead sees after submitting
            </Banner>
          )}
          <CheckBadge size={72} />
          <div className="mt-7"><FirmBlock dark logoUrl={logoUrl} firm={firm} display={ty.display} /></div>
          <motion.h1
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.45 }}
            className="lp-serif text-4xl font-bold leading-tight text-white sm:text-5xl"
            data-testid="lp-thankyou-headline"
          >
            {headline}
          </motion.h1>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-slate-300" data-testid="lp-thankyou-message">{sub}</p>
          {showCall && phone && <ContactButtons phone={phone} label={firm || "us"} />}
          {buyerMessage && <BuyerMessage dark text={buyerMessage} firm={firm} />}
          {ty.display.show_timeline && <NextSteps dark steps={ty.timeline} />}
          {reference && (
            <div className="mt-10 font-mono text-[11px] tracking-wider text-slate-500" data-testid="lp-thankyou-reference">Reference #: {reference}</div>
          )}
          {isTest && (
            <Banner testId="lp-thankyou-sandbox" className="mt-6 border border-amber-400/50 bg-amber-400/10 text-amber-200">
              Sandbox submission — logged as a test lead
            </Banner>
          )}
        </div>
      </div>
    </LandingLayout>
  );
};
